export default __webpack_public_path__ + "static/media/example-cz2.097d2f3a.jpg";